import { render } from "./ForgotPassword.vue?vue&type=template&id=057403a1&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"

import "./ForgotPassword.vue?vue&type=style&index=0&id=057403a1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-057403a1"

export default script